import * as Styled from './AppName.styles';

export const AppName = () => (
  <Styled.AppName>
    Web<span>KD</span>
  </Styled.AppName>
);
